import React from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from './ui/accordion';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const FAQSection = ({ onOpenContactForm }) => {
  const header = useScrollAnimation({ threshold: 0.15 });
  const content = useScrollAnimation({ threshold: 0.1 });

  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-white relative overflow-hidden">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#7C3AED]/10 text-[#7C3AED] px-4 py-1.5 rounded-full text-xs font-bold tracking-wide mb-4">
            FAQ
          </span>
          <h2 className="text-4xl sm:text-5xl font-black tracking-tight text-zinc-900 mb-4" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
            Frequently Asked Questions
          </h2>
          <p className="text-base text-zinc-500 leading-relaxed">
            Common questions about trademark registration, USPTO filing, and our services.
          </p>
        </div>

        <div ref={content.ref} className={`max-w-3xl mx-auto scroll-fade-up scroll-delay-2 ${content.isVisible ? 'scroll-visible' : ''}`}>
          <Accordion type="single" collapsible>
            {faqs.map((faq) => (
              <AccordionItem key={faq.id} value={`item-${faq.id}`} data-testid={`faq-item-${faq.id}`} className="border-b border-zinc-200">
                <AccordionTrigger className="text-left text-sm font-semibold text-zinc-900 hover:text-[#7C3AED] py-5 [&[data-state=open]]:text-[#7C3AED]">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-sm text-zinc-500 leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          <div className="text-center mt-12 pt-8 border-t border-zinc-100">
            <p className="text-sm text-zinc-500 mb-4">Still have questions?</p>
            <Button
              data-testid="faq-cta"
              onClick={onOpenContactForm}
              className="bg-gradient-to-r from-[#7C3AED] to-[#6D28D9] hover:from-[#6D28D9] hover:to-[#5B21B6] text-white font-semibold px-8 h-11 rounded-full active:scale-[0.97] shadow-lg shadow-purple-500/20"
            >
              Talk to an Expert <ArrowRight className="ml-2 w-4 h-4" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
